/**
 * Where a visitor was going when they started to sign up, kept in localStorage for half an hour.
 * It used to be sessionStorage, which a second tab cannot see: Google's sign-in on a phone often
 * comes back in a new tab, and the new account then landed on the AI Agent. In the 14 days to
 * 2026-10-18, 10 of the 34 accounts made from a sign-up aimed at AI Clipping never reached it.
 */
export const KEPT = 'cs_signup_redirect';
export const KEEP_MS = 30 * 60 * 1000;

const local = () => (typeof window !== 'undefined' ? window.localStorage : null);

export function rememberIntent(to, storage = local(), now = Date.now()) {
  try { storage?.setItem(KEPT, JSON.stringify({ to, at: now })); } catch { /* storage refused */ }
}

export function pendingIntent(storage = local(), now = Date.now()) {
  try {
    const raw = storage?.getItem(KEPT);
    if (!raw) return null;
    const { to, at } = JSON.parse(raw);
    if (typeof to !== 'string' || !to.startsWith('/') || to.startsWith('//') || !(now - at < KEEP_MS)) {
      storage.removeItem(KEPT);
      return null;
    }
    return to;
  } catch {
    return null;
  }
}

export function forgetIntent(storage = local()) {
  try { storage?.removeItem(KEPT); } catch { /* storage refused */ }
}
